module.exports = __webpack_public_path__ + "img/logo_tagline.10f55b29.svg";